import React from 'react';
import { Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

export const CopyButton = ({ text, size = "small" }) => {
  const handleCopy = () => {
    if (text && text !== 'nan' && text !== '') {
      navigator.clipboard.writeText(text);
      message.success('Copiado al portapapeles');
    }
  };

  if (!text || text === 'nan' || text === '') return null;

  return (
    <Button
      type="text"
      size={size}
      icon={<CopyOutlined />}
      onClick={handleCopy}
      style={{ marginLeft: 4 }}
    />
  );
};
